/**
 * Настройка Хранилища состояния приложения Vuex
 */
import Vue from 'vue';
import Vuex, { Module, Store } from 'vuex';
import merge from 'deepmerge';
import * as NS from './namespace';

// подлючение модулей-состояния отдельных частей приложения
// общее
import { AppModule } from './modules/app';
// сайдбар
import { SidebarModule } from './modules/sidebar';
// авторизация
import { AuthModule } from './modules/auth';

// администрирование
import AdministrationModule from '@/pages/Administration/store';
// просмотр
import ViewingModule from '@/pages/Viewing/store';

// инициализация использования vuex
Vue.use(Vuex);

// Важно включить инстументы разработчика ДО создания store. Иначе не получится его отслеживать
Vue.config.devtools = true;

// определяем состояние для хранилища
const store: Store<NS.IState> = new Vuex.Store({
    state: [],
    plugins: [],
});

/**
 * Функция для регистрации модулей Vuex по строковой константе - имени модуля
 * @param moduleName - имя регистриуемого модуля
 * @param module - объект модуля
 */
export const registerModule = (moduleName: string, module: Module<any, any>) => {
    const moduleIsRegistered: boolean = (store as any)._modules.root._children[moduleName] !== undefined;
    const stateExists: boolean = store.state[moduleName] !== undefined;

    if (stateExists) {
        module.state = merge(module.state, store.state[moduleName], {
            clone: false,
            arrayMerge: /* istanbul ignore next */ (target: any, source: any) => {
                return source;
            },
        });
    }

    if (!moduleIsRegistered) {
        store.registerModule(moduleName, module, { preserveState: false });
    }
};

// общестистемные модули
registerModule('app', AppModule);
registerModule('sidebar', SidebarModule);
registerModule('auth', AuthModule);

// модули отдельных страниц
registerModule('administration', AdministrationModule);
registerModule('viewing', ViewingModule);

/**
 * Получить экземпляр глобального хранилища vuex
 */
export default store;
